import { defineStore } from 'pinia';

export const useEnvPropsStore = defineStore('envProps', {
  state: () => ({
    envProps: null,
  }),
});
